import styled from 'styled-components';

export const HiddenButton = styled.button`
  display: none;
`;
